import { useState, useId } from 'react';
import { AiOutlineClose } from 'react-icons/ai';

import { TextInputV2 } from '../InputsV2';

const COLORS = ['red', 'yellow', 'green', 'orange', 'blue', 'purple', 'gray'];

interface TagsInputProps {
  id: string;
  onChange?: (value: string[]) => void;
}

export const TagsInput = ({ id, onChange }: TagsInputProps) => {
  const [tags, setTags] = useState<
    { value: string; label: string; color: string }[]
  >([]);
  const [inputValue, setInputValue] = useState('');

  const tagId = useId();

  const selectColor = () => {
    const index = Math.floor(Math.random() * (COLORS.length - 0) + 0);

    return COLORS[index];
  };

  const renderTags = () => {
    return tags.map((t, i) => {
      return (
        <div
          key={t.value}
          className={`ml-1 mt-1 p-1 flex justify-center items-center rounded text-[14px]`}
          style={{ backgroundColor: t.color }}
        >
          {t.label}
          <div
            className="mr-2 text-[10px] cursor-pointer"
            onClick={() => {
              setTags(tags.filter((tt, ii) => ii !== i));
            }}
          >
            <AiOutlineClose />
          </div>
        </div>
      );
    });
  };

  return (
    <div className="w-full px-1 pb-1 flex justify-start items-center flex-wrap border rounded-[6px]">
      {renderTags()}
      <div className="flex-grow min-w-[150px]">
        <TextInputV2
          id={id}
          value={inputValue}
          onChange={(value) => {
            setInputValue(value);
          }}
          onEnter={(value) => {
            setTags([
              ...tags,
              { value: tagId, label: value, color: selectColor() },
            ]);

            setInputValue('');
          }}
          bgColorClassName="!bg-transparent"
          inputExtraClassNames="px-1 pb-0 border-none"
        />
      </div>
    </div>
  );
};
